import React, {memo, useState, useCallback, useEffect, useRef} from 'react';
import {usePreventDragging} from 'components/effects/preventDragging.js';
import {OSCILLATOR} from 'constants/effect-types.js';
import { connect } from "react-redux";
import Arrow from './Arrow.js';
import NodeIO from './NodeIO.js';
import {
    INPUT,
    OUTPUT,
    FONT_SIZES,
    NODE_WIDTH,
    NODE_COLOR,
    NODE_HEIGHTS} from './constants.js';

const selectedColor = "red";

const NodeComponent = memo(({
    rack,
    effect,
    x,
    y,
    text,
    hasInput,
    hasOutput,
    feedbackParam,
    setDragging,
    color,
    rackRef,
    connectEdge,
    startDrawingEdge,
    drawingEdge,
    selected,
    selectedEdge,
    setSelectedEdge,
    edges}) =>
{
    let {preventDragging} = usePreventDragging({ref: rackRef, effect: rack});
    if (!text) {
        text = effect.name;
        if (effect.getText && effect.getText()) {
            text += ": " + effect.getText();
        }
        hasInput = true;
        hasOutput = true;
    } 

    let width = text ? text.length * 6 : 0;
    if (width < 40) {
        width = 40;
    }
    let outputs = hasOutput ? [undefined] : [];
    let inputs = hasInput ? [undefined] : [];

    const onMouseDown = useCallback((e) => {
        // e.stopPropagation();
        preventDragging(false);
        if (!setDragging) {
            return;
        }
        let rect = rackRef.current.getBoundingClientRect();
        setDragging({
            effect,
            x: (e.clientX - rect.left) - x,
            y: (e.clientY - rect.top) - y,
            origX: effect.x,
            origY: effect.y,
        });
    }, [setDragging, x, y]);

    let nodeColor = selected ? selectedColor : color ? color : rack.getEffectType() === OSCILLATOR ?
        "#ff0076" : NODE_COLOR;

    let feedback = [];
    if (effect.feedback) {
        feedback = (
            <Arrow
              strokeWidth={2}
              className="oscillator-edge"
              pointerLength= {6}
              pointerWidth={8}
              stroke={window.baseColor}
              fill={window.baseColor}
              points={[x + 8, y + NODE_HEIGHTS[rack.getEffectType()],
                       x - 8, y + NODE_HEIGHTS[rack.getEffectType()],
                       x - 8, y,
                       x + 8, y
                      ]}/>
        );
    }
    
    return (
        <g>
         <rect
           className={selected ? "selected node" : "node"}
           onMouseDown={(e) => onMouseDown(e)}
           fill={nodeColor}
           opacity={effect.enabledParameter === undefined ? 1 : effect.enabledParameter.get() ? 1 : 0.2}
           x={x}
           y={y}
           width={width}
           height={NODE_HEIGHTS[rack.getEffectType()]}/>
         <text
           onMouseDown={(e) => onMouseDown(e)}
           className={selected ? "selected node-text" : "node-text"}
           fill={"white"}
           fontFamily='Arial'
           x={x+3}
           y={rack.getEffectType() === OSCILLATOR ? y + 15 : y+12}
         >{text}
         </text>
         
          {inputs.map(
             (n,i) => 
                  <NodeIO
                    x={x}
                    y={y}
                    key={'intput-' + i}
                    number={i+1}
                    mode={INPUT}
                    parameter={n}
                    effect={effect}
                    connectEdge={connectEdge}
                    rack={rack}
                    drawingEdge={drawingEdge}
                    selectedEdge={selectedEdge}
                    startDrawingEdge={startDrawingEdge}
                    />)}
          {outputs.map(
            (n,i) =>
                  <NodeIO
                    key={'output-' + i}
                    x={x}
                    y={y}
                    parameter={n}
                    setSelectedEdge={setSelectedEdge}
                    selectedEdge={selectedEdge}
                    rack={rack}
                    drawingEdge={drawingEdge}
                    number={i+1}
                    mode={OUTPUT}
                    connectEdge={connectEdge}
                    startDrawingEdge={startDrawingEdge}
                    effect={effect}
                />)}
          {feedback}
        </g>
    );
});

const mapStateToProps = (state, props) => {
    if (props.x !== undefined) {
        return {};
    }
    let params = {};
    if (props.effect.getVisualizedParameters) {
        let _params = props.effect.getVisualizedParameters();
        for (let param of _params) {
            params[param.id] = param.get(true);
        }
    }
    return {
        ... params,
        x: props.effect.x,
        y: props.effect.y,
        feedbackParam: props.effect.feedback,
        enabled: props.effect.enabledParameter && props.effect.enabledParameter.get()
    };
};

export default connect(mapStateToProps, null)(NodeComponent);
